module.exports = __webpack_public_path__ + "static/media/handtool.88c40b5b.jpg";